<template>
    <div>
        <div
            class="select"
            :class="{ 'is-danger' : errors.has(formName) }"
        >
            <select
                v-model="localValue.value"
                :name="formName"
                v-validate="'required'"
            >
                <option
                    v-for="(o,i) in options"
                    :key="i"
                    :value="o.value"
                >
                    {{o.label}}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    inject : ['$validator'],
    props : {
        value : {
        },
        formName : {
            type : String,
            required : true,
        },
        options : {
            type : Array,
            required : true,
        },
    },
    computed : {
        localValue : {
            get () { return this.value },
            set () { this.$emit('input', this.localValue )}
        },
        selectedOption () {
            return this.options.find(o => { return o.value === this.localValue.value }) || {};
        },
    },
    methods : {
        getLabel () {
            return `${this.selectedOption.label}`;
        },
    }
}
</script>

<style scoped>
</style>
